import Image from '@creator/ui/components/Image/Image';
import { mergeProps } from '@creator/ui/utils/merge-props/merge-props';
import { propsEqualityFn } from '@src/utils/object-utils/object-utils';
import { memo } from 'react';
import type { FC, PropsWithChildren } from 'react';
import Icon, { type IconProps } from '../Icon/Icon';

export type EditorJSMediaBlock = 'video' | 'audio';

export interface MediaProps {
    className?: string;
    type?: EditorJSMediaBlock;
    poster?: string;
    src: string;
    audioIconProps?: IconProps;
    autoplay?: boolean;
    muted?: boolean;
}

const Media: FC<PropsWithChildren<MediaProps>> = props => {
    const { className = '', src, poster = '', type = 'video', audioIconProps = {} } = props;

    const renderVideo = () => {
        return <video autoPlay={true} muted={true} playsInline={true} className="overflow-hidden aspect-video" controls poster={poster} src={src} />;
    };

    const renderAudioPoster = () => {
        if (poster) return <Image className="w-full mb-2" src={poster} />;

        const mergedIconProps = mergeProps<[IconProps, Partial<IconProps>]>(
            {
                svgFill: false,
                name: 'volume',
                className: 'text-[120px]',
            },
            audioIconProps,
        );

        return (
            <div className="flex items-center justify-center w-full text-gray-50 bg-primary-500 aspect-video">
                <Icon {...mergedIconProps} />
            </div>
        );
    };

    const renderAudio = () => {
        return (
            <div className="relative">
                {renderAudioPoster()}
                <audio className="w-full" controls src={src} />
            </div>
        );
    };

    const renderContent = () => {
        if (type === 'audio') return renderAudio();

        return renderVideo();
    };

    return renderContent();
};

export default memo(Media, propsEqualityFn);
